import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import useElements from "../hooks/useElements";
import { migrateElement } from "./image-migration";
const Image = ({
  value,
  aspectRatio,
  className,
  withContainer,
  stopAction
}) => {
  const wuiltContext = useElements();
  const element = migrateElement(value.id || "fake-id", value);
  const ImageComponent = /*#__PURE__*/React.createElement(ElementsViewer.Image, {
    element: {
      ...element,
      id: value.id || element.id
    },
    wuiltContext: wuiltContext,
    asBackground: !!aspectRatio,
    customClassName: className,
    aspectRatio: aspectRatio?.replace(":", "/"),
    stopAction: stopAction
  });
  if (withContainer) {
    return /*#__PURE__*/React.createElement("div", {
      className: withContainer
    }, ImageComponent);
  }
  return ImageComponent;
};
export default Image;
//# sourceMappingURL=Image.js.map